<template>
  <dl class="grid grid-cols-definition-list gap-2">
    <slot />
  </dl>
</template>
